import styled from "styled-components";
import {IInput} from "components";

export const TextArea = styled.textarea<IInput>`
	border-radius: 20px;
	border: 1px solid ${({has_error}) => (has_error ? "#C80502" : "#B8B8B8")};
	width: 100%;
	max-width: 100%;
	height: 180px;
	padding-left: 20px;
	padding-top: 10px;
	resize: none;
	color: #000;
`;
